import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import en from 'vuetify/es5/locale/en'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        background1: '#f7f1eb',
        primary: '#6e9887',
        secondary: '#e4cdc0',
        accentColor: '#be9885',
        textAccentColor: '#8a736d',

        // Global
        textColor: '#484041',
        success: '#05af0c',
        info: '#0A96C2',
        warning: '#C29A0A',
        error: '#C20A0A'
      }
    }
  },
  lang: {
    locales: { en },
    current: 'en'
  },
  icons: {
    iconfont: 'mdi'
  }
})
